import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';
import bundleNS from './constants/bundleNS';
import { getUserId } from '../../localStorages';

export default data => {
  const newData = data;
  newData.userId = getUserId() || newData.userId || null;
  const dataCreate = parseToMutationRequest(newData, bundleNS);
  const createBundle = `createBundle(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createBundle} {
      id
    }
  }
`;
};
